import { render } from "./Vouchers.vue?vue&type=template&id=12453055&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import "@/assets/css/Vouchers.css?vue&type=style&index=0&id=12453055&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12453055"]])

export default __exports__